module.exports = __WEBPACK_EXTERNAL_MODULE_156__;


//////////////////
// WEBPACK FOOTER
// external "semver"
// module id = 156
// module chunks = 0